import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import store from 'store/store';
import themeData from 'utils/theme/themeData';
import { AppModeProvider } from 'contexts/AppModeContext';
import MainContainer from 'modules/common/containers/MainContainer';
import ToastsContainer from 'modules/common/components/Toast/ToastContainer';

const App = () => (
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider theme={themeData}>
        <AppModeProvider>
          <ToastsContainer />
          <MainContainer />
        </AppModeProvider>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);

export default App;
